// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const maushold_family_of_three: PokeData = {
  "id": 10257,
  "name": "maushold-family-of-three",
  "height": 3,
  "weight": 28,
  "base_experience": 165,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "super-fang",
    "charm",
    "encore",
    "beat-up",
    "follow-me",
    "helping-hand",
    "hyper-voice",
    "bullet-seed",
    "copycat",
    "double-hit",
    "echoed-voice",
    "play-rough",
    "baby-doll-eyes",
    "population-bomb",
    "tidy-up"
  ],
  "moves": [
    "hyper-voice",
    "bullet-seed",
    "play-rough",
    "splash",
    "growl",
    "purification",
    "body-slam",
    "supersonic",
    "scary-face",
    "scratch",
    "leer",
    "tackle",
    "refresh"
  ],
  "evolution_chain": {
    "id": 485,
    "item": null,
    "species": [
      {
        "name": "tandemaus",
        "order": 945,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "maushold",
        "order": 946,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 924,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 113,
    "speed": 171,
    "ability_power": 116
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
